import React from 'react'
import { ShowImagePlaceholder } from './ShowImagePlaceholder' 

export class ShowImage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            imageLoaded: false
        }
        this.handleImageLoad = this.handleImageLoad.bind(this)
    }

    handleImageLoad() {
        this.setState({ imageLoaded: true })
    }

    render() {
        const { imgUrl } = this.props
        const { imageLoaded } = this.state

        return (
            <>
                {!imageLoaded && (
                    <ShowImagePlaceholder />
                )}

                <img
                    onLoad={this.handleImageLoad}
                    src={imgUrl}
                    style={{
                        width: '100%',
                        maxWidth: 250,
                        maxHeight: 312,
                        objectFit: 'cover',
                        borderRadius: 0,
                        marginBottom: 12,
                        display: imageLoaded ? 'block' : 'none'
                    }}
                />
            </>
        )
    }
}